import { Url } from "../url";
import client from "../client";
import { format } from "react-string-format";

async function _participantsPrivacy(version, language) {
  const url = format(Url.participants_privacy, version, language);
  return await client().get(url);
}

async function _participantsTerms(version, language) {
  const url = format(Url.participants_terms_of_use, version, language);
  return await client().get(url);
}

async function _participantsPrivacyLanguages(version) {
  const url = format(Url.participants_privacy_languages, version);
  return await client().get(url);
}

async function _participantsTermsLanguages(version) {
  const url = format(Url.participants_terms_of_use_languages, version);
  return await client().get(url);
}

async function _userPrivacy(version, language) {
  const url = format(Url.clinical_team_privacy, version, language);
  return await client().get(url);
}

async function _userTerms(version, language) {
  const url = format(Url.clinical_team_terms_of_use, version, language);
  return await client().get(url);
}

async function _userPrivacyLanguages(version) {
  const url = format(Url.clinical_team_privacy_languages, version);
  return await client().get(url);
}

async function _userTermsLanguages(version) {
  const url = format(Url.clinical_team_terms_of_use_languages, version);
  return await client().get(url);
}

async function _support(language) {
  const url = format(Url.support, language);
  return await client().get(url);
}

async function _supportLanguages() {
  return await client().get(Url.support_languages);
}

async function _translations() {
  return await client().get(Url.translations);
}

export {
  _participantsPrivacy as participantsPrivacy,
  _participantsTerms as participantsTerms,
  _userPrivacy as userPrivacy,
  _userTerms as userTerms,
  _support as support,
  _participantsPrivacyLanguages as participantsPrivacyLanguages,
  _participantsTermsLanguages as participantsTermsLanguages,
  _userPrivacyLanguages as userPrivacyLanguages,
  _userTermsLanguages as userTermsLanguages,
  _supportLanguages as supportLanguages,
  _translations as translations
};
